import { Grid } from "@material-ui/core";
import { Block, Done } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { getDateTime } from "app/common/LocalFunction";
import { pagingServiceItem } from "app/services/PatientServiceRegisterService";
import { observer } from "mobx-react";
import { forwardRef, memo } from "react";
function UpdateMainServiceRegisterPopup({
  open,
  handleClose,
  onConfirm,
  initialValues,
  handleAfterSubmit,
}) {
  console.log("initialValues", initialValues);
  return (
    <PopupForm
      size="sm"
      open={open}
      handleClose={handleClose}
      title="Cập nhật đơn hàng bảo hành"
      formik={{
        initialValues: initialValues,
        enableReinitialize: true,

        onSubmit: async (values, { setSubmitting }) => {
          await onConfirm(values, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        },
      }}
      action={(values, isSubmitting) => {
        return (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" />
              Hủy
            </CommonButton>
            <CommonButton
              type="submit"
              className="btn-danger"
              disabled={isSubmitting}
            >
              <Done className="mr-2" />
              Cập nhật
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, isSubmitting }) => {
        return (
          <>
            <Grid container spacing={1} alignItems="center">
              {/* Label */}
              <Grid item xs={12} sm={3} md={3} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontWeight: 500 }}>Đơn hàng bảo hành:</span>
              </Grid>

              {/* Autocomplete */}
              <Grid item xs={12} sm={9} md={9}>
                <GlobitsPagingAutocomplete
                  api={pagingServiceItem}
                  searchObject={{
                    patientId: values?.patientId,
                    getAllServiceInTreatment: true,
                    excludeWarranty: true,
                  }}
                  name={"mainServiceRegister"}
                  renderOption={(option) => {
                    let label = option?.name;
                    if (option?.code) label += ` - ${option.code}`;
                    if (option?.orderDate) label += ` - ${getDateTime(option.orderDate)}`;
                    return <div style={{ fontWeight: 500 }}>{label}</div>;
                  }}
                  getOptionDisabled={(option) => values?.id === option?.id}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(UpdateMainServiceRegisterPopup));
